<div class="container" style="width: 700px">
  <app-recipients-selector
    [alert]="alert"
  ></app-recipients-selector>
  <div class="display-flex flex-align-center justify-content-end">
    <app-button type="button"
                icon="chevron_right"
                iconPosition="right"
                buttonType="mat-flat-button"
                [disabled]="alert.payload.relationships.user_notifications_subscriber.data.lenght === 0 "
                (onClick)="onSubmit()">{{ 'button.next' | translate }}
    </app-button>
  </div>
</div>
